// the design's Icons "pause": two 5.95 x 22.1 bars (radius 1.2)
export const PauseIcon = () => (
  <svg
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='white'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <rect x='8.08' y='5.95' width='5.95' height='22.1' rx='1.2' />
    <rect x='19.98' y='5.95' width='5.95' height='22.1' rx='1.2' />
  </svg>
)
